var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.183 10.808L21.067 11.692L13.125 19.6339L8.93297 15.442L9.81703 14.558L13.125 17.8661L20.183 10.808ZM27.5 15C27.5 21.8925 21.8925 27.5 15 27.5C8.1075 27.5 2.5 21.8925 2.5 15C2.5 8.1075 8.1075 2.5 15 2.5C21.8925 2.5 27.5 8.1075 27.5 15ZM26.25 15C26.25 8.79672 21.2033 3.75 15 3.75C8.79672 3.75 3.75 8.79672 3.75 15C3.75 21.2033 8.79672 26.25 15 26.25C21.2033 26.25 26.25 21.2033 26.25 15Z",
    fill: "#00884A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.bc6b12e4dca2cbe5f065af8310fc5853.svg";
export { ForwardRef as ReactComponent };